new nc.promokit.Player({
    selector:'#player-main',
    videoId: 'https://vod.plaync.com/lineage2/promo/yvgm.mp4',
    mute:true,
    autoPlay:true,
    loop:true
});

var pre = new nc.promokit.Preloader({
    'game': 'lineage2',
    'image': [
        '/promo/lineage2/event/2020/200205_gotmail/img/mist.png',
        '/promo/lineage2/event/2020/200205_gotmail/img/state-recommend.png',
        '/promo/lineage2/event/2020/200205_gotmail/img/state-story.png',
        '/promo/lineage2/event/2020/200205_gotmail/img/sec1-con1-bg.jpg',
        '/promo/lineage2/event/2020/200205_gotmail/img/sec1-con2-bg.jpg',
        '/promo/lineage2/event/2020/200205_gotmail/img/sec1-con3-bg.jpg',
        '/promo/lineage2/event/2020/200205_gotmail/img/sec1-con4-bg.jpg',
        '/promo/lineage2/event/2020/200205_gotmail/img/sec1-con5-bg.jpg',
        '/promo/lineage2/event/2020/200205_gotmail/img/sec1-con6-bg.jpg',
        '/promo/lineage2/event/2020/200205_gotmail/img/sec2-con1-bg.jpg',
        '/promo/lineage2/event/2020/200205_gotmail/img/sec2-con2-bg.jpg',
        '/promo/lineage2/event/2020/200205_gotmail/img/sec2-con3-bg.jpg',
        '/promo/lineage2/event/2020/200205_gotmail/img/sec3-con1-bg.jpg',
        '/promo/lineage2/event/2020/200205_gotmail/img/sec3-con2-bg.jpg'
    ]
});

$(document).on('preloadend', function(){
    setTimeout(function () {
        var tl = new TimelineMax();
        tl.to('#tit1-1', 1.3, {ease:Power1.easeOut,y:-50, opacity: 1})
            .to('#tit1-2', 1.2, {ease:Power1.easeOut,y:-50, opacity: 1},"-=0.9")
            .to('#tit1-3', 1.2, {ease:Power1.easeOut,y:-50, opacity: 1},"-=0.9")
            .to('#tit2', 1.8, {ease:Power2.easeOut, width:'449px',x:-225, opacity: 1},"-=0.8")
            .to('#tit3-1', 1, {ease:Power1.easeOut,y:-50, opacity: 1},"-=0.8")
            .to('#tit3-2', 1, {ease:Power1.easeOut,y:-50, opacity: 1},"-=0.6")
            .to('#tit3-3', 1, {ease:Power1.easeOut,y:-50, opacity: 1},"-=0.6")
            .to('#tit4', 1.9, {ease:Power3.easeOut, clip:'rect(0px, 484px, 38px, 0)', opacity: 1},"-=0.5");
    },500);

    $('body').TopBtn();
    $('.toggle-caution').Folding({open: true});

    new nc.promokit.remote({
        element:"#remoteMenu",
        margin:-100,
        top:920,
        fix:287,
        show:true,
        quick:true,
        cspeed:600
    });

    window.blocktype = function (el) {
        /* ie8 이상 / edge */
        if (document.documentMode || /Edge/.test(navigator.userAgent))
            $(el).attr({readonly:'readonly'});
        else
            $(el).attr({disabled:'disabled'});
    };

    $('.p-banner__close').on('click', function () {
        $('.p-banner').addClass('p-banner--close');
    })
});


// WEBPACK FOOTER //
// ./src/js/index.js